import { render, staticRenderFns } from "./GetOrderReportData.vue?vue&type=template&id=23b52a7c&scoped=true&"
import script from "./GetOrderReportData.vue?vue&type=script&lang=js&"
export * from "./GetOrderReportData.vue?vue&type=script&lang=js&"
import style0 from "./GetOrderReportData.vue?vue&type=style&index=0&id=23b52a7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b52a7c",
  null
  
)

export default component.exports